import { CLASSIFICATION_MODAL_CLOSE } from 'containers/ResolutionCenter/AccountTakeOverClassificationModal/constants'
import { FETCH_ASSIGNEES_ASYNC } from 'containers/ResolutionCenter/Report/constants'

import { ATO_STATES } from '../constants'

import {
  ACTIONS_LIST,
  CHANGE_INCIDENT_STATE_REQUEST_ASYNC,
  RESET_REMEDIATION_CONFIRMATION,
  TOGGLE_REMEDIATION_ACTION,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    error: null,
    page: 1,
    remediationActions: {
      // [ACTIONS_LIST.RESET_PASSWORD]: true,
      [ACTIONS_LIST.DISABLE_SIGNIN]: false,
      [ACTIONS_LIST.SIGN_OUT]: true,
    },
    showRemediationConfirmation: false,
    assignees: {
      loader: false,
      error: null,
      data: [],
    },
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case CHANGE_INCIDENT_STATE_REQUEST_ASYNC.INITIATE: {
        return {
          ...state,
          error: null,
          loader: true,
        }
      }
      case CHANGE_INCIDENT_STATE_REQUEST_ASYNC.SUCCESS: {
        return {
          ...state,
          error: null,
          loader: false,
          // Only Remediate has a post-action confirmation step (the list of performed actions).
          // Safe has none — the modal closes instead (see the classification modal reducer).
          showRemediationConfirmation:
            action.payload?.newState === ATO_STATES.COMPROMISED ? state.remediationActions : false,
        }
      }
      case CHANGE_INCIDENT_STATE_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          loader: false,
        }
      case CHANGE_INCIDENT_STATE_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          showRemediationConfirmation: false,
        }
      // Closing the modal any way (Close button, X, Esc) drops the confirmation step — otherwise a
      // stale one hides the confirm button the next time the modal opens.
      case CLASSIFICATION_MODAL_CLOSE:
      case RESET_REMEDIATION_CONFIRMATION:
        return {
          ...state,
          showRemediationConfirmation: false,
        }
      case TOGGLE_REMEDIATION_ACTION:
        return {
          ...state,
          remediationActions: {
            ...state.remediationActions,
            [action.payload.actionType]: !state.remediationActions[action.payload.actionType],
          },
        }
      case FETCH_ASSIGNEES_ASYNC.INITIATE: {
        return {
          ...state,
          assignees: { ...state.assignees, loader: true },
        }
      }
      case FETCH_ASSIGNEES_ASYNC.SUCCESS: {
        return {
          ...state,
          assignees: {
            loader: false,
            error: null,
            data: action.payload.data,
          },
        }
      }
      case FETCH_ASSIGNEES_ASYNC.ERROR:
        return {
          ...state,
          assignees: {
            loader: false,
            data: [],
            error: action.error.response?.message,
          },
        }
      default:
        return state
    }
  }
}
